import Cookies from "js-cookie";
import TenantAPI, { getTokenForSupportalSupportedEndpoints } from "./TenantAPI";
import API from "./API";
import { InstallAppPayload } from "../api-hooks/globalApps/useInstallGlobalApp";
import { GlobalAppPayload } from "../api-hooks/globalApps/useUploadGlobalApp";

export default class GlobalAppAPI {
  static async getGlobalApps() {
    return API._bearerRequest(
      "get",
      `/tenant/global-apps/`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getGlobalAppByID(globalAppID: string) {
    return API._bearerRequest(
      "get",
      `/tenant/global-apps/getByID/${globalAppID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async uploadGlobalApp(payload: GlobalAppPayload, workspaceID: string) {
    return API._bearerRequest(
      "post",
      `/tenant/global-apps/upload-app/${workspaceID}`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async revokeGlobalApp(appID: string, workspaceID: string) {
    return API._bearerRequest(
      "delete",
      `/tenant/global-apps/delete/${appID}/${workspaceID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async installGlobalApp(payload: InstallAppPayload) {
    const supportTargetCloudID = payload.supportTargetCloudID;

    return API._bearerRequest(
      "post",
      `/tenant/global-apps/install/${payload.globalAppID}${
        supportTargetCloudID ? `?tenantID=${supportTargetCloudID}` : ""
      }`,
      { workspaceID: payload.workspaceID },
      getTokenForSupportalSupportedEndpoints(supportTargetCloudID)
    );
  }

  static async uninstallGlobalApp(
    globalAppID: string,
    workspaceID: string,
    deleteEverything: boolean
  ) {
    const queryParams = deleteEverything
      ? "?deleteModules=true&deleteRecords=true"
      : "";

    return API._bearerRequest(
      "delete",
      `/tenant/global-apps/uninstall/${globalAppID}/${workspaceID}${queryParams}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async addGlobalAppToWorkspace(payload: InstallAppPayload) {
    return API._bearerRequest(
      "post",
      `/tenant/global-apps/add-to-workspace/${payload.globalAppID}`,
      { workspaceID: payload.workspaceID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async removeGlobalAppFromWorkspace(
    globalAppID: string,
    workspaceID: string
  ) {
    return API._bearerRequest(
      "delete",
      `/tenant/global-apps/remove-from-workspace/${globalAppID}/${workspaceID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getGlobalAppViews(
    globalAppID: string,
    type: "views" | "subviews"
  ) {
    return API._bearerRequest(
      "get",
      `/tenant/global-apps/get-global-app-views/${globalAppID}/${type}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
